import { ZonedDate } from '@eika-infrastruktur/date';

import type { AccountNumber, EFaktura, EFakturaId, Kid } from '../../../../generated-types';
import { SelectedReceiver } from '../../SelectedReceiver';

export enum PaymentActionType {
    INIT_FORM = 'INIT_FORM',
    FROM_ACCOUNT_SELECTED = 'FROM_ACCOUNT_SELECTED',
    TO_ACCOUNT_SELECTED = 'TO_ACCOUNT_SELECTED',
    AMOUNT = 'AMOUNT',
    NOTE = 'NOTE',
    PAYMENT_DATE = 'PAYMENT_DATE',
    SET_KID = 'SET_KID',
    SHOW_FROM_ACCOUNTS = 'SHOW_FROM_ACCOUNTS',
    HIDE_FROM_ACCOUNTS = 'HIDE_FROM_ACCOUNTS',
    RESET = 'RESET',
    SET_EFAKTURA_ID = 'SET_EFAKTURA_ID',
    SET_INITIAL_KID_AND_NOTE = 'SET_INITIAL_KID_AND_NOTE',
}

export type PaymentAction =
    | { type: PaymentActionType.INIT_FORM; payload: { eFaktura: EFaktura } }
    | { type: PaymentActionType.FROM_ACCOUNT_SELECTED; payload: AccountNumber }
    | { type: PaymentActionType.TO_ACCOUNT_SELECTED; payload: SelectedReceiver }
    | { type: PaymentActionType.AMOUNT; payload?: number }
    | { type: PaymentActionType.NOTE; payload: string }
    | { type: PaymentActionType.PAYMENT_DATE; payload?: ZonedDate }
    | { type: PaymentActionType.SET_KID; payload?: Kid }
    | { type: PaymentActionType.SHOW_FROM_ACCOUNTS }
    | { type: PaymentActionType.HIDE_FROM_ACCOUNTS }
    | { type: PaymentActionType.RESET }
    | { type: PaymentActionType.SET_INITIAL_KID_AND_NOTE; payload: { kid: Kid | undefined; note: string | undefined } }
    | { type: PaymentActionType.SET_EFAKTURA_ID; payload: EFakturaId | undefined };
